import firebase from 'firebase/app';
import Collection, { COLLECTION_REGISTER } from './collection';
import User from './user';
import Session from './session';
import Part from './part';
import Board from './board';
import SessionAttribute from './session/session-attributes';

const users: Collection<User> = new Collection({
  type: User,
  path: 'user'
});

const admins: Collection = new Collection({
  type: User,
  path: 'useradmin'
});

const session: Collection<Session> = new Collection({
  type: Session,
  path: 'session'
});

const sessionAttr: Collection<SessionAttribute> = new Collection({
  type: SessionAttribute,
  path: 'session-attribute'
});

const part: Collection<Part> = new Collection({
  type: Part,
  path: 'part'
});

const board: Collection<Board> = new Collection({
  type: Board,
  path: 'board'
});

const db = {
  users,
  admins,
  session,
  sessionAttr,
  part,
  board,
  unwatchAll: () => COLLECTION_REGISTER.forEach(c => c.unwatch()),
  DELETE: firebase.firestore.FieldValue.delete
};
export default db;
